import { SVGProps } from 'react'

export const BracketDialog = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      viewBox="0 0 13 119"
      fill="none"
      preserveAspectRatio="none"
      {...props}
    >
      <path
        d="M12.2336 117.622H0.5V0.5H12.2336"
        stroke="url(#paint0_linear_4734_9433)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4734_9433"
          x1="18.1366"
          y1="0.515616"
          x2="40.7385"
          y2="112.992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E6E6E" stopOpacity="0.3" />
          <stop offset="0.486365" stopColor="#6E6E6E" />
          <stop offset="1" stopColor="#6E6E6E" stopOpacity="0.3" />
        </linearGradient>
      </defs>
    </svg>
  )
}
